export default __webpack_public_path__ + "static/media/img6.8c3e6644.png";